import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import qs from 'query-string';
import React from 'react';
import {withLoginRequired} from 'rev.sdk.js/Components/LoginRequired';
import SiteNavBar from '../SiteNavBar';
import LoginRequired from '../LoginRequired';
import ProfileMenu, {ProfileTabs} from '../ProfileTabs';
import * as CustomLayout from '../../Utils/CustomLayout';

function ProfileLayout(props) {
  const {style = {}} = props;
  const [user] = useOutlet('user');
  const [dimension] = useOutlet('dimension');
  const activePath = props.location.pathname.split('/')[2];
  const params = qs.parse(props.location.search);
  const mobile = dimension.rwd === 'mobile';

  function renderCustomSection(sectionId) {
    return CustomLayout.renderProfileCustomSection(sectionId, activePath, {
      ...params,
    });
  }

  if (user && user.tmp) {
    return (
      <Wrapper style={{...style}} rwd={dimension.rwd}>
        <div className="content">
          <h3>匿名使用者無法瀏覽本頁面</h3>
        </div>
      </Wrapper>
    );
  }

  return (
    <Wrapper style={{...style}} rwd={dimension.rwd}>
      {renderCustomSection('A')}

      <div className="content">
        {renderCustomSection('B')}

        <div
          style={{display: 'flex', flexDirection: mobile ? 'column' : 'row'}}>
          {mobile ? (
            <ProfileTabs activePath={activePath} />
          ) : (
            <div style={{display: 'flex', flexDirection: 'column'}}>
              {renderCustomSection('C')}

              <ProfileMenu activePath={activePath} />

              {renderCustomSection('D')}
            </div>
          )}

          <div style={{height: 20, width: 20}} />

          <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
            {renderCustomSection('E')}

            <div>{props.children}</div>
          </div>
        </div>

        {renderCustomSection('J')}
      </div>

      {renderCustomSection('K')}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topNavBarHeight);

  & > .content {
    max-width: var(--contentMaxWidth);
    min-height: var(--contentMinHeight);
    margin: 0 auto;
    padding: 30px
      ${(props) =>
        props.rwd === 'desktop' ? 0 : props.rwd === 'tablet' ? 50 : 20}px;
  }
`;

export default withLoginRequired(ProfileLayout, {
  admin: false,
  SiteNavBar,
  renderLoginRequired: LoginRequired,
});
